import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { track, eventCategories, analyticsEvents } from "util/analytics";

import SaveWrapper from "..";

import styles from "./styles.module.scss";

const SaveIcon = ({
  id,
  buildingId,
  signUpType,
  className,
  bookMarkSavedClass,
  bookMarkNotSavedClass,
  source,
  areaExternalIds,
  marketOfInterest,
  cityOfInterest,
  leaseTermMin,
  leaseTermMax,
  minPricePerSquareFoot,
  maxPricePerSquareFoot,
  minSqft,
  maxSqft,
  minMonthlyPrice,
  maxMonthlyPrice,
  numEmployees,
  phoneRequired,
  trackingEvent,
  onSuccess,
}) => {
  return (
    <SaveWrapper
      inquiribleId={id}
      buildingId={buildingId}
      signUpType={signUpType}
      source={source}
      type="Listing"
      areaExternalIds={areaExternalIds}
      marketOfInterest={marketOfInterest}
      cityOfInterest={cityOfInterest}
      leaseTermMin={leaseTermMin}
      leaseTermMax={leaseTermMax}
      minPricePerSquareFoot={minPricePerSquareFoot}
      maxPricePerSquareFoot={maxPricePerSquareFoot}
      minSqft={minSqft}
      maxSqft={maxSqft}
      minMonthlyPrice={minMonthlyPrice}
      maxMonthlyPrice={maxMonthlyPrice}
      numEmployees={numEmployees}
      phoneRequired={phoneRequired}
      onSuccess={(visitSpace) => {
        track(analyticsEvents.save_listing, {
          category: eventCategories.listings,
          label: `building: ${buildingId}, listing: ${id}`,
        });
        if (visitSpace) {
          track(analyticsEvents.request_tour, {
            category: eventCategories.listings,
            label: `building: ${buildingId}, listing: ${id}`,
          });
        }
        onSuccess(visitSpace);
      }}
    >
      {(saveListing, isSaved) => (
        <button
          type="button"
          className={cn(styles.button, className)}
          disabled={isSaved}
          onClick={(e) => {
            trackingEvent();
            saveListing(e);
          }}
          data-qa="bookmark"
        >
          <svg
            className={styles.bookmark}
            xmlns="http://www.w3.org/2000/svg"
            width="28px"
          >
            <path
              className={
                isSaved
                  ? cn(bookMarkSavedClass, styles.saved)
                  : cn(bookMarkNotSavedClass, styles.notSaved)
              }
              d="M18.444 21l-6.222-4.444L6 21V6.778C6 5.796 6.796 5 7.778 5h8.889c.982 0 1.777.796 1.777 1.778V21z"
            />
          </svg>
        </button>
      )}
    </SaveWrapper>
  );
};

SaveIcon.defaultProps = {
  className: "",
  bookMarkSavedClass: "",
  bookMarkNotSavedClass: "",
  source: null,
  areaExternalIds: [],
  marketOfInterest: null,
  cityOfInterest: null,
  leaseTermMin: null,
  leaseTermMax: null,
  minPricePerSquareFoot: null,
  maxPricePerSquareFoot: null,
  minSqft: null,
  maxSqft: null,
  minMonthlyPrice: null,
  maxMonthlyPrice: null,
  numEmployees: null,
  phoneRequired: false,
  trackingEvent: () => { },
  // eslint-disable-next-line no-unused-vars
  onSuccess: (_visitSpace) => { },
};

SaveIcon.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  buildingId: PropTypes.string.isRequired,
  signUpType: PropTypes.string.isRequired,
  bookMarkSavedClass: PropTypes.string,
  bookMarkNotSavedClass: PropTypes.string,
  source: PropTypes.string,
  areaExternalIds: PropTypes.arrayOf(PropTypes.string),
  marketOfInterest: PropTypes.string,
  cityOfInterest: PropTypes.string,
  leaseTermMin: PropTypes.number,
  leaseTermMax: PropTypes.number,
  minPricePerSquareFoot: PropTypes.number,
  maxPricePerSquareFoot: PropTypes.number,
  minSqft: PropTypes.number,
  maxSqft: PropTypes.number,
  minMonthlyPrice: PropTypes.number,
  maxMonthlyPrice: PropTypes.number,
  numEmployees: PropTypes.string,
  phoneRequired: PropTypes.bool,
  trackingEvent: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default SaveIcon;
